import { render, staticRenderFns } from "./Wells.vue?vue&type=template&id=64323caa"
import script from "./Wells.vue?vue&type=script&lang=js"
export * from "./Wells.vue?vue&type=script&lang=js"
import style0 from "./Wells.vue?vue&type=style&index=0&id=64323caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports